import { useMemo } from 'react';
import { Box, Typography, Divider } from '@material-ui/core';
import clsx from 'clsx';
import { Link } from '@setvi/shared/interfaces';
import { SPreviewEditor } from '@setvi/shared/components';
import { TContact } from '@setvi/shared/components/sdrawer-content/components/contact';
import { usePreview } from './usePreview';
import { TextWrapper, BodyWrapper, Title, useStyles } from './style';
import { parseHtmlForPreview } from '../../utils';

export interface SPreviewProps {
  emailSubject: string;
  emailBody: string;
  variables?: any[];
  links?: Link[];
  selectedRecipient?: TContact;
  showRecipientValues?: boolean;
  fillHeight?: boolean;
}

const SPreview = ({
  emailSubject,
  emailBody,
  variables = [],
  links = [],
  selectedRecipient,
  showRecipientValues = false,
  fillHeight = false
}: SPreviewProps) => {
  const classes = useStyles();

  const { htmlPreviewSubject, htmlPreviewBody } = usePreview({
    emailSubject,
    emailBody,
    variables,
    links,
    selectedRecipient,
    showRecipientValues
  });

  const shouldEnableLinkClicks = useMemo(
    () =>
      links.length > 0 && links.every(link => link?.Item?.Items?.length > 0),
    [links]
  );

  const editorContent = showRecipientValues
    ? parseHtmlForPreview(htmlPreviewBody, true)
    : htmlPreviewBody;

  const Wrapper = fillHeight ? BodyWrapper : TextWrapper;

  const content = (
    <>
      <Box mt={2} mb={2} className={classes.subjectSection}>
        <Box mb={1}>
          <Title variant="body2">Subject</Title>
        </Box>
        <TextWrapper>
          <Typography
            display="inline"
            className={clsx(
              classes.subjectContainer,
              !showRecipientValues && classes.variableStyles
            )}>
            {htmlPreviewSubject}
          </Typography>
        </TextWrapper>
      </Box>
      <Divider className={classes.divider} />
      <Box className={fillHeight ? classes.bodySection : undefined}>
        <Box mb={1}>
          <Title variant="body2">Email body</Title>
        </Box>
        <Wrapper>
          <SPreviewEditor
            content={editorContent}
            variables={variables}
            showVariableValues={showRecipientValues}
            recipient={selectedRecipient}
            enableLinkClicks={shouldEnableLinkClicks}
            height={fillHeight ? '100%' : undefined}
          />
        </Wrapper>
      </Box>
    </>
  );

  if (fillHeight) {
    return <Box className={classes.container}>{content}</Box>;
  }

  return content;
};

export default SPreview;
